import { c as _c } from "react/compiler-runtime";
import { SignInButton } from '@clerk/clerk-react';
import { Button } from '../ui/button';
import { Card, CardHeader } from '../ui/card';
import { VODojoLogo } from '../VODojoLogo';
export const WebSignInCTA = () => {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <VODojoLogo size={64} />;
    t1 = <h2 className="text-2xl font-bold">Welcome to VODOjo</h2>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CardHeader className="pt-2 flex flex-row gap-4 items-center justify-center">{t0}<div>{t1}<p className="text-muted-foreground">Sign in to continue or{" "}<a className="text-blue-500 underline" href="https://vodojo.net">return to the homepage</a></p></div></CardHeader>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Card className="w-full max-w-md p-3 shadow-2xl shadow-gray-800">{t2}<SignInButton><Button size="lg">Sign In</Button></SignInButton></Card>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};